import { Button as RawButton } from './Button';
import { Theme } from '@mui/material/styles';

type LogoutButtonProps = {
  textButton?: string;
  type?: 'link' | 'button';
  style?: Record<string, unknown>;
  logout?: () => void;
};

const LogoutButton = ({ textButton, type, style, logout }: LogoutButtonProps) => {
  return (
    <RawButton
      style={style}
      sx={(theme: Theme) => {
        if (type === 'link') {
          return {
            minHeight: '0px',
            display: 'flex',
            flexFlow: 'row nowrap',
            color: theme.palette.neutral[80],
            background: 'none',
            borderRadius: '0px',
            textTransform: 'none',
            height: '55px',
            paddingLeft: '24px',
            width: '100%',
            justifyContent: 'left',
            backgroundColor: theme.palette.neutral.white,
            transition: 'none',
            '&:hover': {
              backgroundColor: theme.palette.blue[20],
              color: theme.palette.blue[60],
              fontSize: theme.typography.body2SemiBold.fontSize,
              fontWeight: theme.typography.body2SemiBold.fontWeight,
              fontFamily: theme.typography.body2SemiBold.fontFamily,
            },
          };
        }
        return {
          border: 'none',
          padding: '0.7em 3.5em',
          borderRadius: 20,
          backgroundColor: theme.palette.red[60],
          boxShadow: '2px 2px 5px rgb(201, 201, 201)',
          margin: '0.8em auto',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          '&:hover': {
            cursor: 'pointer',
            backgroundColor: theme.palette.neutral.white,
            color: theme.palette.red[60],
            transition: '0.51s ease',
          },
        };
      }}
      textButton={textButton || 'Se déconnecter'}
      onClick={() => {
        sessionStorage.clear();
        localStorage.clear();
        logout && logout();
      }}
    />
  );
};

export default LogoutButton;
export { LogoutButton };
